import React from 'react'
import CardServicosVentures from './cardServicosVentures'
import Container from './container'

export default function LinksVentures({ areasData }) {
  if (!areasData || areasData.length === 0) {
    return null
  }

  return (
    <div className="w-full bg-[#040116] py-20 relative overflow-hidden">
      {/* Background com grafismos */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="/assets/grafismos.svg"
          className="w-full h-full object-cover"
          alt=""
        />
        <img
          src="/assets/grafismos.svg"
          className="absolute inset-0 w-full h-full object-cover rotate-180"
          alt=""
        />
      </div>
            
      <div className="text-center space-y-8 relative z-10">
          <h2 className="text-white text-2xl md:text-5xl font-inter-bold leading-[1.4] md:leading-[1.2]">
              Startups do{" "}
              <span className="font-inter-light text-white">
                  nosso ecossistema
              </span>
          </h2>
      </div>

      <Container className="relative z-10 mt-18">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-6">
          {areasData.map((area, index) => (
            <CardServicosVentures
              key={index}
              logo={area.logo}
              text={area.text}
              glowColor={area.glowColor}
              url={area.url}
              className="md:w-full lg:w-[430px]"
              height="360"
            />
          ))}
        </div>
      </Container>
    </div>
  )
}
